import {v4 as uuidv4} from "uuid";
import {faker} from '@faker-js/faker';

var fixedPatches = [
  {
    kbnumber: "2006634",
    title: "Microsoft Office Accounting 2009 Service Pack 3 (KB2006634)",
    product: "Office 2007",
    family: "Office",
    classification: "ServicePacks",
    severity: "Unspecified",
    description: `Service Pack 3 for Microsoft Office Accounting 2009 provides 
                  the latest updates to Microsoft Office Accounting 2009. This 
                  service pack contains stability and performance enhancements.`
  },
  {
    kbnumber: "2028888",
    title: "Update for Office Communicator 2007 R2 (KB 2028888)",
    product: "Office Communicator 2007 R2",
    family: "Office Communications Server And Office Communicator",
    classification: "UpdateRollups",
    severity: "Unspecified",
    description: "This package fixes the issues described in KB 2028888."
  },
  {
    kbnumber: "2032276",
    title: "Security Update for Windows 7 for x64-based Systems (KB2032276)",
    product: "Windows7",
    family: "Windows",
    classification: "Updates",
    severity: "Important",
    description: `A security issue has been identified that could allow an unauthenticated 
                  remote attacker to compromise your system and gain control over it. You can 
                  help protect your system by installing this update from Microsoft. After you 
                  install this update, you may have to restart your system.`
  },
  {
    kbnumber: "2124261",
    title: "Security Update for Windows Server 2008 (KB2124261)",
    product: "WindowsServer2008",
    family: "Windows",
    classification: "SecurityUpdates",
    severity: "Important",
    description: `A security issue has been identified that could allow an unauthenticated remote 
                  attacker to compromise your system and gain control over it. You can help protect 
                  your system by installing this update from Microsoft. After you install this update, 
                  you may have to restart your system.`
  },
  {
    kbnumber: "2077208",
    title: "Update for Microsoft Office 2010 (KB2077208)",
    product: "Office 2010",
    family: "Office",
    classification: "CriticalUpdates",
    severity: "Unspecified",
    description: `Microsoft has released an update for Microsoft Office 2010. This update provides 
                  the latest fixes to the Microsoft Office 2010 Click-2-Run deployment mechanism. 
                  Additionally, this update allows anti-virus and anti-malware scan of virtualized 
                  Microsoft Office 2010.`
  },
  {
    kbnumber: "2006634",
    title: "Microsoft Office Accounting 2009 Service Pack 3 (KB2006634)",
    product: "Office 2007",
    family: "Office",
    classification: "ServicePacks",
    severity: "Unspecified",
    description: `Service Pack 3 for Microsoft Office Accounting 2009 provides 
                  the latest updates to Microsoft Office Accounting 2009. This 
                  service pack contains stability and performance enhancements.`
  },
  {
    kbnumber: "2028888",
    title: "Update for Office Communicator 2007 R2 (KB 2028888)",
    product: "Office Communicator 2007 R2",
    family: "Office Communications Server And Office Communicator",
    classification: "UpdateRollups",
    severity: "Unspecified",
    description: "This package fixes the issues described in KB 2028888."
  },
  {
    kbnumber: "2032276",
    title: "Security Update for Windows 7 for x64-based Systems (KB2032276)",
    product: "Windows7",
    family: "Windows",
    classification: "Updates",
    severity: "Important",
    description: `A security issue has been identified that could allow an unauthenticated 
                  remote attacker to compromise your system and gain control over it. You can 
                  help protect your system by installing this update from Microsoft. After you 
                  install this update, you may have to restart your system.`
  },
  {
    kbnumber: "2124261",
    title: "Security Update for Windows Server 2008 (KB2124261)",
    product: "WindowsServer2008",
    family: "Windows",
    classification: "SecurityUpdates",
    severity: "Important",
    description: `A security issue has been identified that could allow an unauthenticated remote 
                  attacker to compromise your system and gain control over it. You can help protect 
                  your system by installing this update from Microsoft. After you install this update, 
                  you may have to restart your system.`
  },
  {
    kbnumber: "2077208",
    title: "Update for Microsoft Office 2010 (KB2077208)",
    product: "Office 2010",
    family: "Office",
    classification: "CriticalUpdates",
    severity: "Unspecified",
    description: `Microsoft has released an update for Microsoft Office 2010. This update provides 
                  the latest fixes to the Microsoft Office 2010 Click-2-Run deployment mechanism. 
                  Additionally, this update allows anti-virus and anti-malware scan of virtualized 
                  Microsoft Office 2010.`
  }
];


export const allPatches = () => {
  const patches = [];
  fixedPatches.forEach(patch => {
    let _patch = {
      "KbNumber": patch.kbnumber,
      "Title": patch.title,
      "Product": patch.product,
      "ProductFamily": patch.family,
      "Classification": patch.classification,
      "MsrcSeverity": patch.severity,
      "Description": patch.description
    };
    _patch.Language = "All";
    _patch.Vendor = "Microsoft";
    _patch.MsrcNumber = "";
    _patch.Id = uuidv4();
    _patch.ReleaseDate = faker.date.past();
    _patch.ContentUrl = `https://support.microsoft.com/en-us/kb/${_patch.KbNumber}`
    _patch.KbNumber = `KB${_patch.KbNumber}`
    patches.push(_patch);
  });
  
  return {
    "Patches" : patches
  }
}


